import { render, staticRenderFns } from "./dui-popover.vue?vue&type=template&id=7631bc2c&scoped=true&"
import script from "./dui-popover.vue?vue&type=script&lang=js&"
export * from "./dui-popover.vue?vue&type=script&lang=js&"
import style0 from "./dui-popover.vue?vue&type=style&index=0&id=7631bc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631bc2c",
  null
  
)

export default component.exports